import React, { useState, useEffect } from 'react'
import { X } from 'lucide-react'
import './styles.scss'

export default function EditAgentTaskModal({ isOpen, onClose, onSave, rule }) {
  const [agentTaskId, setAgentTaskId] = useState('')
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (isOpen && rule) {
      setAgentTaskId(rule.linqraAgentTaskId || '')
    } else {
      setAgentTaskId('')
    }
  }, [isOpen, rule])

  if (!isOpen || !rule) return null

  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)
    try {
      await onSave(rule.id, agentTaskId)
      onClose()
    } catch (err) {
      console.error(err)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="modal-overlay">
      <div className="modal-content fade-in edit-agent-task-modal">
        <div className="modal-header">
          <h2>Edit Agent Task ID</h2>
          <button className="btn-close" onClick={onClose}><X size={20} /></button>
        </div>
        <form onSubmit={handleSubmit} className="modal-form">
          <div className="form-group">
            <label>Rule Description</label>
            <input type="text" value={rule?.description || ''} disabled className="form-control read-only-input" />
          </div>
          
          <div className="form-group">
            <label>Linqra Agent Task ID</label>
            <input 
              type="text" 
              value={agentTaskId} 
              onChange={e => setAgentTaskId(e.target.value)} 
              placeholder="e.g. 6a33738dc7669b77134eee91"
              className="form-control"
            />
            <small className="help-text">
              This links the document type to a specific AI Agent Verification Task.
            </small>
          </div>

          <div className="modal-actions">
            <button type="button" className="btn btn-outline" onClick={onClose} disabled={loading}>
              Cancel
            </button>
            <button type="submit" className="btn btn-primary" disabled={loading}>
              {loading ? 'Saving...' : 'Save Task ID'}
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}
